import React, { useState, useContext, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import Login from './login'
import SignUp from './signup'
import { AuthContext, UserType } from '../../../contexts/authContext'
import Layout from '../../common/layout/layout'
import { useLocation } from 'react-router-dom'

function Onboarding() {
  const authContext = useContext(AuthContext)
  const [showLogin, setShowLogin] = useState(true)
  const search = useLocation().search

  if (authContext?.userType !== UserType.vendor) {
    authContext?.setUserType(UserType.vendor)
  }

  useEffect(() => {
    const query = new URLSearchParams(search)
    if (query.get('action') === 'signup') {
      setShowLogin(false)
    } else {
      setShowLogin(true)
    }
  }, [search])

  return (
    <Layout>
      <Row>
        <Col xs={12} className="pt-5">
          <h1 className="largeTitle">Welcome!</h1>
        </Col>
      </Row>
      <Row>
        <Col md={8} lg={5} className="mx-auto mt-5">
          {showLogin ? <Login /> : <SignUp />}
        </Col>
      </Row>
    </Layout>
  )
}

export default Onboarding
